import { ofType } from 'redux-observable';
import { mergeMap, debounceTime } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { GET_WATCH_LIST_ENTRIES_BY_WATCH_LIST } from '../types';
import { WATCH_LIST_ENTRY_MESSAGES } from '../constants/watchListEntryMessages';
import { getWatchListEntriesByWatchListPending, getWatchListEntriesByWatchListFulfilled, getWatchListEntriesByWatchListRejected } from '../actions';
import { sendApiRequest, notifyError, notifyWarning } from '../../../actions';
import { watchListEntriesByWatchListFiltersSelector } from '../selectors';
import generateError from '../../../utilities/generateError';

const createPayload = payload => ({
  method: 'get',
  url: 'watchlistentry/get',
  onSuccess: [response => (response.data.length === 0
    ? notifyWarning(WATCH_LIST_ENTRY_MESSAGES.NOT_FOUND)
    : getWatchListEntriesByWatchListFulfilled(response))],
  onError: [
    getWatchListEntriesByWatchListRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: 'ajaxApi',
};

const getWatchListEntriesByWatchListEpic$ = (action$, state$) => action$.pipe(
  ofType(GET_WATCH_LIST_ENTRIES_BY_WATCH_LIST.DEFAULT),
  debounceTime(500),
  mergeMap(({ payload }) => {
    const filters = watchListEntriesByWatchListFiltersSelector(state$.value);

    return merge(
      of(getWatchListEntriesByWatchListPending()),
      of(sendApiRequest(createPayload({ ...payload, ...filters }), meta)),
    );
  }),
);


export default getWatchListEntriesByWatchListEpic$;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/epics/getWatchListEntriesByWatchListEpic.js